import Page from "../pages/Login";
import { pageMeta } from "../lib/meta";
export const meta = () => pageMeta({ title: "Sign in | Gazar", description: "Sign in to your Gazar account.", path: "/login" });
export default function Login() { return <Page />; }
